// extracted by mini-css-extract-plugin
module.exports = {"bordered":"lR","expired":"mR","inactiveTitleBar":"nR","title":"oR","titleWrapper":"pR","stepIndex":"qR","changeSectionContainer":"rR"};